import { apiPost, apiStore } from '../../../modules/apiHelper';
import { toBoolean } from '../../../modules/dataHelper';

export default {
  getMenteeTasks(context, strict = false) {
    const menteeStoreData = context.state.tasks;
    // console.log(menteeStoreData);
    if (menteeStoreData.length > 0 && !strict) {
      return menteeStoreData;
    }

    const data = new FormData();
    data.set('menteeid', context.rootState.User.id);

    return apiPost('task_list_mentee', data, 1)
      .catch((err) => {
        console.warn('Cannot get your tasks \n', err);
      })
      .then((res) => {
        if (!res) return false;
        if (toBoolean(res.data.error)) {
          console.warn('Error in getting your tasks \n', res.data.message);
          return false;
        }

        const tasks = res.data.task_list_mentee || [];

        tasks.forEach((task) => {
          context.commit('addTask', task);
        });

        return true;
      });
  },
  async markTaskComplete(context, [taskId, reportText = undefined]) {
    if (!taskId) return false;
    const task = await context.dispatch('getTask', [taskId]);
    const userId = context.getters.userId.toString();

    if (userId !== task.mentorid && userId !== task.userid) return false;

    const formData = new FormData();
    formData.set('taskid', taskId);
    if (reportText) {
      formData.set('text', reportText);
    }

    const response = await apiPost('submit_task_report', formData, 1)
      .catch((err) => {
        console.warn('markTaskComplete ERROR', err);
      })
      .then(async (res) => {
        if (!res) return false;
        if (toBoolean(res.error)) return false;

        // get the updated task Details
        await apiStore.removeItem(`task/${taskId}`);
        context.dispatch('getTask', [taskId])
          .then((newTask) => {
            if (newTask.id) {
              context.commit('updateTask', {
                id: newTask.id,
                prop: 'status',
                value: newTask.status,
              });
            }
          });

        return true;
      });

    return response;
  },
};
